import {AfterViewChecked, Component, ElementRef, EventEmitter, HostBinding, Input, Output, SimpleChanges, ViewChild} from '@angular/core';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Dialog } from 'app/dialogs/model/model';
import { CacheService } from 'shared/cache/cache-service';
import { HyphenateService } from 'shared/helpers/hyphenate.service';

const WORD_WRAP_LIMIT = 10;

@Component({
    selector: 'info-pane',
    templateUrl: 'info-pane.html',
    styleUrls: ['info-pane.scss'],
})
export class InfoPane implements AfterViewChecked {

    private _info: any;
    @Input() public set info(info: any) {
        this.bumpCounter = 42;
        this._info = info;
        const fontCached: any = this.cacheService.get(this.getTextFromInfo(info));
        this.logId = this.getTextFromInfo(info);
        // console.log(">>> read "+(fontCached !== undefined ? fontCached[1] : '')+ " " + this.logId);
        if ( fontCached !== undefined ) {
            // console.log(">>> reded %o "+this.logId, fontCached);
            this.nFontSize = fontCached[0];
            this.bumpHeight = fontCached[1];
            this.bumpHeightIntended = fontCached[1];
            this.innerOpacityDirect = 1;
            this.innerOpacity = 1;
        }
        else {
            setTimeout(() => this.resetText(true));
        }
        this.value = 0;
    }

    public get info(): any {
        return this._info;
    }

    @Output() public dialogClicked: EventEmitter<Dialog> = new EventEmitter<Dialog>();          
    @Output() public textClicked: EventEmitter<void> = new EventEmitter<void>();          
    @Output() public listClicked: EventEmitter<void> = new EventEmitter<void>();
    @Output() public thesisClicked: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('inner') private inner: ElementRef;
    @ViewChild('outer') private outer: ElementRef;
    @ViewChild('bump') private bump: ElementRef;

    public bumpHeight: string = '0';
    public innerOpacity: number = 1;
    public innerOpacityDirect: number = 1; // Indicator ob gesetzt werden soll

    @HostBinding("style.--font-faktor")
    public nFontSize: number = 24;

    private nFontSizeIntended: number = 24;
    private bumpHeightIntended: string = '0';

    private oldText: string = '';

    private bumpCounter = 0;

    public max: number = 5;
    public value: number = 0;

    public moodText = "Wie geht es dir heute?";

    private logId: string = '';

    constructor(
        private hyphenateService: HyphenateService,
        private translateService: TranslateService,
        private cacheService: CacheService,
        private platform: Platform,
    ) {
        this.translateService
        .get('THESES.MOOD_QUESTION')
        .subscribe((text) => {
            this.moodText = text;
        });
        this.platform.ready().then(() => {
            this.platform.resize.subscribe(() => {
                this.cacheService.clearAll();
                if ( this._info != undefined ) {
                    setTimeout(() => this.resetText(true));
                }
            });
          });
    }

    public onDialogClicked(): void {
        if (this.info.dialog.thesis == undefined) {
            this.dialogClicked.emit(this.info.dialog);
        }
    }

    public onTextClicked(): void {
        this.textClicked.emit();
    }

    public onListClicked(): void {
        this.listClicked.emit();
    }

    ngAfterViewChecked() {
        if ( this.innerOpacityDirect == 1 ) {
            return;
        }
        const inner: HTMLSpanElement = this.inner.nativeElement;
        const outer: HTMLButtonElement = this.outer.nativeElement;
        const bump: HTMLDivElement = this.bump.nativeElement;
        if ( this.bumpCounter > 10 ) {
            if ( this.innerOpacityDirect == 0) {
                this.innerOpacityDirect = 1;
                // console.log("infoPane 0"+ " " + this.logId);
                setTimeout(() => this.innerOpacity = 1);
                this.cacheSizes();
            }
            return;
        }
        let changed = false;
        if ( (outer.clientHeight < outer.scrollHeight) && this.bumpHeight != '0') {

            let innerH = inner.offsetHeight;
            let h = innerH - bump.offsetHeight; 
            if ( innerH == 0 ) { // Fix für ios
                if ( inner.lastElementChild && inner.lastElementChild.tagName.toUpperCase() != 'ION-SPINNER' ) {
                    innerH = inner.lastElementChild.clientHeight;
                    h = innerH;
                }
            }
            if ( innerH != 0 ) {
                const d = (outer.clientHeight - h) / 2;
                if ( d > 0 ) {
                    const bumpVal = /*Math.floor(d*0.95)*/d+'px';
                    if ( bumpVal != this.bumpHeightIntended && this.bumpHeight == this.bumpHeightIntended /*&& this.bumpHeight == '5%'*/) {
                        // console.log("infoPane 1"+ " " + this.logId);
                        this.bumpHeightIntended = bumpVal;
                        setTimeout(() => this.bumpHeight = bumpVal);
                        changed = true;
                        this.bumpCounter++;
                    }
                }
                else {
                    // console.log("infoPane 2"+ " " + this.logId);
                    this.bumpHeightIntended = '0';
                    setTimeout(() => this.bumpHeight = '0');
                    changed = true;
                    this.bumpCounter++;
                }
            }
        }
        else if ( outer.clientHeight < outer.scrollHeight ) {
            if ( this.nFontSize >= 1 ) {
                if ( this.nFontSizeIntended == this.nFontSize ) {
                    this.nFontSizeIntended -= 0.5;
                    // console.log("infoPane 3 fontsize: "+this.nFontSizeIntended+ " " + this.logId);
                    setTimeout(() => this.nFontSize = this.nFontSizeIntended);
                }
                changed = true;
            }
        }
        else if ( this.nFontSize == 24 ) {
            let innerH = inner.offsetHeight;
            let h = innerH - bump.offsetHeight; 
            if ( innerH == 0 ) { // Fix für ios
                if ( inner.lastElementChild && inner.lastElementChild.tagName.toUpperCase() != 'ION-SPINNER' ) {
                    innerH = inner.lastElementChild.clientHeight;
                    h = innerH;
                }
            }
            if ( innerH != 0 ) {
                const d = (outer.clientHeight - h) / 2;
                if ( d > 0 ) {
                    const bumpVal = Math.floor(d*0.95)+'px';
                    if ( bumpVal != this.bumpHeightIntended  && this.bumpHeight == this.bumpHeightIntended /*&& this.bumpHeight == '5%'*/) {
                        // console.log("infoPane 4 bumpHeight "+ bumpVal +" " + this.logId);
                        this.bumpHeightIntended = bumpVal;
                        setTimeout(() => this.bumpHeight = bumpVal);
                        changed = true;
                        this.bumpCounter++;
                    }
                }
            }
        }
        if ( !changed && this.innerOpacityDirect == 0) {
            this.innerOpacityDirect = 1;
            // console.log("infoPane 5"+ " " + this.logId);
            setTimeout(() => this.innerOpacity = 1);
            this.cacheSizes();
        }
    }

    private cacheSizes(): void {
        this.cacheService.set(this.getTextFromInfo(this._info), [this.nFontSizeIntended, this.bumpHeightIntended]);
        // console.log(">>> store " + this.bumpHeightIntended + " cnt " + this.bumpCounter + " " + this.logId);
    }

    ngOnChanges(changes: SimpleChanges) {
        //setTimeout(() => this.resetText(false)); // kann das sicher weg?
    }

    onResize(event) {
        // console.log("ZZZ resize: ");
        setTimeout(() => this.resetText(true));
    }

    private resetText(always: boolean) {
        if ( this.inner !== undefined ) {
            const inner: HTMLSpanElement = this.inner.nativeElement;
            const text = inner.innerHTML;
            if ( !always ) {
                if ( text == this.oldText ) {
                    return;
                }
            }
            this.oldText = text;
        }
        this.bumpHeight = '0';
        this.bumpHeightIntended = '0'
        this.nFontSize = 24;
        this.nFontSizeIntended = 24;
        this.innerOpacity = 0;
        this.innerOpacityDirect = 0;
        this.bumpCounter = 0;
        // console.log("ZZZ reset");
    }

    public breakSafe(s: string): string {
        return this.hyphenateService.hyphenate(s);
    }

    public createRating(): Array<boolean> {
        const rating: Array<boolean> = [];
    
        for (let i: number = 0; i < this.max; i++) {
          rating.push(i == (this.value - 1));
        }
        return rating;
      }

    public onStarSelected(event: Event, index: number): void {
        event.preventDefault();
        event.stopImmediatePropagation();
        
        this.value = index + 1;
        this.thesisClicked.emit({thesis: this.info.dialog.thesis, text: this.info.dialog.title, value: this.value});
    }
    
    private getTextFromInfo(info: any): string {
        if ( info == undefined ) {
            return '';
        }
        if (info.title != undefined ) {
            return info.title;
        }
        if (info.text != undefined ) {
            return info.text;
        }
        console.log("## Strange info %o", info);
        return '';
    }

}
